import * as Page from '../../components/content/page-header';
import { MainContent } from '../../components/layout/content';
import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/page-header';
import { ReactComponent as Phone } from '../../assets/icons/iphone.svg';
import { ReactComponent as Laptop } from '../../assets/icons/macbook.svg';
import { ReactComponent as Tablet } from '../../assets/icons/ipad.svg';
import { useParams } from 'react-router-dom';

const sources: { key: string; label: string }[] = [
  { key: 'espn', label: 'ESPN' },
  { key: 'espn-nfl', label: 'ESPN NFL' },
  { key: 'vogue', label: 'Vogue' },
  { key: 'bazar', label: 'Bazar' },
  { key: 'vanity-fair', label: 'Vanity Fair' },
  { key: 'time', label: 'Time' },
  { key: 'ny-times', label: 'The New York Times' },
];

export const PreviewUnits = (): JSX.Element => {
  const [source, setSource] = useState<string>(sources[0].key);
  const { channelId } = useParams();

  const Sources = (): JSX.Element => {
    return (
      <div className="sources">
        <ul>
          {sources.map((item) => {
            return (
              <li
                key={item.key}
                className={source === item.key ? 'active' : ''}
                onClick={(): void => setSource(item.key)}>
                {item.label}
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  const AdPreview = (props: {
    type: 'laptop' | 'tablet' | 'phone';
    code: string;
    image: string;
  }): JSX.Element => {
    return (
      <div className="ad-preview-container">
        <div className="ad-preview-device">
          <div className={`type-${props.type}`}>
            {props.type === 'laptop' && <Laptop />}
            {props.type === 'tablet' && <Tablet />}
            {props.type === 'phone' && <Phone />}
          </div>
        </div>
        <div className="ad-preview-code">
          <textarea>{props.code}</textarea>
          <span className="ad-code-copy">Copy</span>
        </div>
      </div>
    );
  };

  return (
    <>
      <Page.Header>
        <PageHeader
          title="Adunit preview"
          buttons={[
            { title: 'Edit Channel', type: 'link', location: `/channels/${channelId!}/edit` },
            { title: 'Blast', type: 'primary', location: `/channels/${channelId!}/blast` },
          ]}
        />
      </Page.Header>
      <MainContent className="ad-unit-preview">
        <Sources />
        <AdPreview
          type="laptop"
          code={`<script src="${process.env.REACT_APP_EMBED_SCRIPT!}"></script><div id="adc"></div><script> ADC.init({ container: 'adc', props: { type: 'hero', id: '${channelId!}' } });</script>`}
          image={''}
        />
        <AdPreview
          type="tablet"
          code={`<script src="${process.env.REACT_APP_EMBED_SCRIPT!}"></script><div id="adc"></div><script> ADC.init({ container: 'adc', props: { type: 'hero', id: '${channelId!}' } });</script>`}
          image={''}
        />
        <AdPreview
          type="phone"
          code={`<script src="${process.env.REACT_APP_EMBED_SCRIPT!}"></script><div id="adc"></div><script> ADC.init({ container: 'adc', props: { type: 'hero', id: '${channelId!}' } });</script>`}
          image={''}
        />
      </MainContent>
    </>
  );
};
